'use strict'

module.exports.DEFAULT_PAGE_SIZE = 20



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/dataset-configuration/pagination.js